var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"charts"},[_c('Chart',{attrs:{"stats":_vm.stats,"question":_vm.question,"question_id":_vm.question_id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }